module.exports = __webpack_public_path__ + "img/close.6ef8d596.svg";